import React from 'react';
import { Pie } from 'react-chartjs-2';
import { FaInfoCircle } from 'react-icons/fa';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import { Chart as ChartJS } from 'chart.js';
import PropTypes from 'prop-types';
import '../stylesheets/components/Charts.css';

ChartJS.register(ChartDataLabels);

const PieChart = ({
  title = 'Pie Chart Title',
  subtitle = 'Text or Description',
  data,
  legendLabels = [],
  legendColors = [],
  infoTooltip = '',
  value,
}) => {
  const chartData = {
    labels: legendLabels,
    datasets: [
      {
        data: data,
        backgroundColor: legendColors,
        borderWidth: 0,
      },
    ],
  };

  const options = {
    plugins: {
      datalabels: {
        display: true,
        color: 'white',
        font: {
          size: 12,
          weight: 300,
          family: 'Roboto'
        },
        formatter: function(value, context) {
          return value;
        },
        anchor: 'center',
        align: 'center',
        textStrokeColor: 'rgba(0,0,0,0.3)',
        textStrokeWidth: 1,
      },
      legend: { display: false },
      tooltip: { enabled: true },
    },
    cutout: 0, // Pie chart (not doughnut)
    responsive: true,
    maintainAspectRatio: false,
  };

  return (
    <div className="chart-card-container">
      <div className="chart-card__title-row">
        <span className="chart-card__title">{title}</span>
        <span className="chart-card__icon" title={infoTooltip}>
          <FaInfoCircle size={16} color="#A0A0A0" />
        </span>
      </div>
      {typeof value !== 'undefined' && (
        <div className="chart-card__value">{value}</div>
      )}
      <div className="chart-card__subtitle">{subtitle}</div>
      <hr className="chart-card__divider" />
      <div className="chart-card__body--horizontal">
        <div className="pie-chart-wrap">
          <Pie data={chartData} options={options} plugins={[ChartDataLabels]} />
        </div>
        <div className="chart-card__legend-area">
          {legendLabels.map((label, idx) => (
            <div className="custom-legend-item" key={label}>
              <span
                className="custom-legend-color"
                style={{ backgroundColor: legendColors[idx] }}
              />
              <span className="custom-legend-label">{label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

PieChart.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.number).isRequired,
  legendLabels: PropTypes.arrayOf(PropTypes.string),
  legendColors: PropTypes.arrayOf(PropTypes.string),
  infoTooltip: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default PieChart;
